import Authenticator from '../../components/Authenticator/Authenticator';
import { Pages } from '../../components/Pages/Pages';
import useSettings from '../../hooks/useSettings';
import AccommodationPage from '../../pages/AccommodationPage/AccommodationPageDK';
import CitizenshipPage from '../../pages/CitizenshipPage/CitizenshipPageDK';
import CoApplicantPage from '../../pages/CoApplicantPage/CoApplicantPage';
import ContactDetailsPage from '../../pages/ContactDetailsPage/ContactDetailsPage';
import CreditCardPage from '../../pages/CreditCardPage/CreditCardPageDK';
import EmploymentPage from '../../pages/EmploymentPage/EmploymentPageDK';
import EskatKreditStatusConsentPage from '../../pages/EskatKreditStatusPage/EskatKreditStatusConsentPageDK';
// TODO(LP-2856): re-enable once the eskat-kreditstatus data fetch/display flow is picked back up.
// import EskatKreditStatusPage from '../../pages/EskatKreditStatusPage/EskatKreditStatusPageDK';
import FinancePage from '../../pages/FinancePage/FinancePageDK';
import HowToApplyPage from '../../pages/HowToApplyPage/HowToApplyPage';
import LivingConditionPage from '../../pages/LivingConditionPage/LivingConditionPageDK';
// TODO(LP-xxxx): re-enable once the montio/experian credit-check flow is picked back up.
// import MontioPage from '../../pages/MontioPage/MontioPageDK';
import PepPage from '../../pages/PepPage/PepPage';
import PurposeOfLoanPage from '../../pages/PurposeOfLoanPage/PurposeOfLoanPageDK';
import SubmitPage from '../../pages/SubmitPage/SubmitPageDK';

const SubmitApplicationWizard = () => {
    const settings = useSettings();

    return (
        <Pages>
            <HowToApplyPage />
            <EskatKreditStatusConsentPage />
            {/* TODO(LP-2856): re-enable once the eskat-kreditstatus data fetch/display flow is picked back up. */}
            {/* <EskatKreditStatusPage /> */}
            <Authenticator autoLogin={true}>
                <ContactDetailsPage />
            </Authenticator>
            <Authenticator autoLogin={true}>
                <LivingConditionPage />
            </Authenticator>
            <Authenticator autoLogin={true}>
                <AccommodationPage />
            </Authenticator>
            <Authenticator autoLogin={true}>
                <EmploymentPage />
            </Authenticator>
            <Authenticator autoLogin={true}>
                <CitizenshipPage />
            </Authenticator>
            {/* TODO(LP-xxxx): re-enable once the montio/experian credit-check flow is picked back up. */}
            {/* <Authenticator autoLogin={true}>
                <MontioPage />
            </Authenticator> */}
            <Authenticator autoLogin={true}>
                <FinancePage />
            </Authenticator>
            <Authenticator autoLogin={true}>
                <CreditCardPage />
            </Authenticator>
            <Authenticator autoLogin={true}>
                <PepPage />
            </Authenticator>
            <Authenticator autoLogin={true}>
                <PurposeOfLoanPage />
            </Authenticator>
            {settings.withCoApplicant && (
                <Authenticator autoLogin={true}>
                    <CoApplicantPage />
                </Authenticator>
            )}
            <Authenticator autoLogin={true}>
                <SubmitPage />
            </Authenticator>
        </Pages>
    );
};

export default SubmitApplicationWizard;
